let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("26IOy"), load("2nuqm"), load("c6MKV"), load("aZinD"), load("iOJdB")]).then(() => parcelRequire('452sv'));